export default "__VITE_ASSET__FAkKGQAA__"